import { render, staticRenderFns } from "./OnboardPurpose.vue?vue&type=template&id=08ab58d3"
import script from "./OnboardPurpose.vue?vue&type=script&lang=ts"
export * from "./OnboardPurpose.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports